const Chat = () => import('./Chat.vue')

export default [
  {
    name: 'chat',
    path: 'chat',
    component: Chat,
    meta: {
      access: ['org.communication.chat.view']
    }
  }
]
